<script>

import {mapActions} from "vuex";
import axios from 'axios';

export default {

    computed: {
        isAuthenticated() {
            if (!this.$page.props.auth) {
                return false;
            }

            return !!this.$page.props.auth.email;
        },

        products() {
            return this.cart.items ?? [];
        },

        subTotal() {
            let total = 0;

            this.products.forEach(product => total += this.totalProductPrice(product));

            return total;
        },

        taxes() {
            let taxes = {};

            this.products.forEach(product => {
                if (!product.product.taxrate || !product.product.price) {
                    return;
                }

                if (!taxes[product.product.taxrate]) {
                    taxes[product.product.taxrate] = 0;
                }

                taxes[product.product.taxrate] += product.quantity * (Math.round((product.product.price / 100) * product.product.taxrate));
            });

            return taxes;
        },

        taxTotal() {
            let total = 0;
            Object.values(this.taxes).forEach(inc => total += inc);
            return total;
        },

        total() {
            return this.subTotal + this.taxTotal;
        },
    },

    methods: {
        ...mapActions([
            'fetchCart',
        ]),

        decreaseQuantity(product) {
            if (product.quantity < 1) {
                return;
            }

            product.quantity -= 1;
        },

        increaseQuantity(product) {
            product.quantity += 1;
        },

        removeProduct(product) {
            this.$GA4.dispatch('remove_from_cart');

            axios.delete(this.route('api.v1.cart.destroy', {uuid: product.product.uuid}))
                .then(() => this.fetchCart());

            this.$snotify.success(this.lang('snotify.success.open.cart.deleted'));
        },

        totalProductPrice(product) {
            if (!product.product.price) {
                return 0;
            }

            return product.quantity * product.product.price;
        },
    },

    name:'CartBaseCart',

    props: {
        cart: {
            required:true,
            type:Object,
        },
    },

}

</script>
